import { generatePath, createSearchParams } from 'react-router-dom';

import { PUBLIC_SUBJECT } from 'global/public-routes.constants';
import { SubjectFragment } from 'approot/shared/graphql/startup-data/__generated__/SubjectFragment';
import { getUserClassPath } from 'approot/classes/classes.apollo';
import Breadcrumbs from 'approot/shared/layout/breadcrumbs/breadcrumbs';
import { GetStartupData_startupData_years } from '../graphql/startup-data/__generated__/GetStartupData';
import { useYearTranslation } from 'approot/shared/logic/years';
import { setContentFilterData } from 'approot/shared/filters/filters.apollo';

type ContentItem = {
  name: string;
  slug: string;
};

type Props = {
  subject: SubjectFragment;
  years: GetStartupData_startupData_years[];
  topic: ContentItem;
  unit?: ContentItem;
  item?: ContentItem;
};

const ContentPageBreadcrumbs = ({
  subject,
  years,
  topic,
  unit,
  item,
}: Props) => {
  const { formatYears } = useYearTranslation();

  const crumbs = [
    {
      label: subject.label || '',
      href: getUserClassPath(
        generatePath(PUBLIC_SUBJECT, {
          subject: subject.name,
        })
      ),
    },
    {
      label: formatYears(years.map(y => y.name)) || '',
      href: `${getUserClassPath(
        generatePath(PUBLIC_SUBJECT, {
          subject: subject.name,
        })
      )}?${createSearchParams({
        years: years.map(y => y.name),
      })}`,
      // prevent both a user's class preferences and any previous selections
      // override years from the url params
      onClick: () =>
        setContentFilterData({
          readPreferenceFilter: false,
          yearFilter: null,
        }),
    },
    {
      label: topic.name,
      href: getUserClassPath(topic.slug),
    },
  ];

  if (unit) {
    crumbs.push({
      label: unit.name,
      href: getUserClassPath(unit.slug),
    });
  }

  if (item) {
    crumbs.push({
      label: item.name,
      href: item.slug,
    });
  }

  return (
    <Breadcrumbs
      breadcrumbs={crumbs}
      breadcrumbsSmall={[crumbs[crumbs.length - 2]]}
    />
  );
};

export default ContentPageBreadcrumbs;
